import { render, staticRenderFns } from "./MacchinaStreaming.vue?vue&type=template&id=6a64266b&"
import script from "./MacchinaStreaming.vue?vue&type=script&lang=js&"
export * from "./MacchinaStreaming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports